// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { Permission } from '@Constants/Permission.g';
import { type MenuElement } from '@Hooks/Navigation/types';
import {
    IconAddressBook,
    IconBox,
    IconClipboardList,
    IconDownload,
    IconFileInvoice,
    IconHome,
    IconUsers,
} from '@tabler/icons-react';
import { useMemo } from 'react';

/**
 * Flat navigation for portal sessions. Kept apart from {@link useMainMenuElements} so ERP and
 * portal structure can change independently; every entry points at an existing ERP route.
 */
export const usePortalMenuElements = (): MenuElement[] =>
    useMemo(
        () => [
            {
                kind: 'leaf',
                name: 'PortalHome',
                label: 'Startseite',
                icon: IconHome,
                link: '/home',
                permissions: [],
            },
            {
                kind: 'leaf',
                name: 'PortalRequisitions',
                label: 'Bestellungen',
                icon: IconClipboardList,
                link: '/requisitions',
                permissions: [Permission.AuftragsbearbeitungRequisitionsRead],
            },
            {
                kind: 'leaf',
                name: 'PortalContainerStock',
                label: 'Meine Container',
                icon: IconBox,
                link: '/container_stock',
                permissions: [Permission.AuftragsbearbeitungContainerStockRead],
                featureFlag: 'CONTAINER_SERVICE',
            },
            {
                kind: 'leaf',
                name: 'PortalInvoices',
                label: 'Rechnungen',
                icon: IconFileInvoice,
                link: '/invoices',
                permissions: [Permission.BillingInvoiceSnapshotsRead],
            },
            {
                kind: 'leaf',
                name: 'PortalDownloads',
                label: 'Downloads',
                icon: IconDownload,
                link: '/downloads',
                permissions: [Permission.DocumentsDocumentRead],
            },
            {
                kind: 'leaf',
                name: 'PortalAddresses',
                label: 'Meine Adressen',
                icon: IconAddressBook,
                link: '/stammdaten/addresses',
                permissions: [Permission.StammdatenAddressesRead],
            },
            {
                kind: 'group',
                name: 'Systemverwaltung',
                label: 'Systemverwaltung',
                icon: IconUsers,
                targets: [
                    { link: '/permissions/groups', label: 'Gruppen', permissions: [Permission.PermissionsGroupsRead] },
                    { link: '/permissions/users', label: 'Benutzer', permissions: [Permission.PermissionsUsersRead] },
                ],
            },
        ],
        [],
    );
